module.exports = __webpack_public_path__ + "img/toxis-promo.075132fa.png";